import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  GET_DEALTAG,
  DELETE_DEALTAG,
  UPDATE_DEALTAG,
  ADD_NEW_DEALTAG,
} from "./actionType";

import {
  getDealTagSuccess,
  getDealTagFail,
  deleteDealTagSuccess,
  deleteDealTagFail,
  updateDealTagSuccess,
  updateDealTagFail,
  addDealTagSuccess,
  addDealTagFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveDealTagApi,
  getDealTagApi,
  updateDealTagApi,
  deleteDealTagApi,
  addNewDealTagApi,
} from "../../helpers/backend_helper";

function* getDealTag({ payload: dealTag }) {
  try {
    const response = yield call(getDealTagApi, dealTag);
    yield put(getDealTagSuccess(GET_DEALTAG, response.data));
  } catch (error) {
    yield put(getDealTagFail(GET_DEALTAG, error));
  }
}

function* onUpdateDealTag({ payload: dealTag }) {
  try {
    if (dealTag.setApprove) {
      const response = yield call(approveDealTagApi, dealTag);
      yield put(updateDealTagSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    } else {
      const response = yield call(updateDealTagApi, dealTag);
      yield put(updateDealTagSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateDealTagFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteDealTag({ payload: dealTag }) {
  try {
    const response = yield call(deleteDealTagApi, dealTag);
    yield put(deleteDealTagSuccess({ dealTag, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteDealTagFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewDealTag({ payload: dealTag }) {
  try {
    const response = yield call(addNewDealTagApi, dealTag);
    yield put(addDealTagSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addDealTagFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

export function* watchGetDealTag() {
  yield takeEvery(GET_DEALTAG, getDealTag);
}

export function* watchUpdateDealTag() {
  yield takeEvery(UPDATE_DEALTAG, onUpdateDealTag);
}

export function* watchDeleteDealTag() {
  yield takeEvery(DELETE_DEALTAG, onDeleteDealTag);
}

export function* watchAddNewDealTag() {
  yield takeEvery(ADD_NEW_DEALTAG, onAddNewDealTag);
}

function* dealTagSaga() {
  yield all([
    fork(watchGetDealTag),
    fork(watchDeleteDealTag),
    fork(watchUpdateDealTag),
    fork(watchAddNewDealTag),
  ]);
}

export default dealTagSaga;
